module.exports = __webpack_public_path__ + "static/desk-2fa1e867f9d9ccca1c3d45cde1144387.jpg";